import Vue from 'vue';
import VueRouter from 'vue-router';

import vuetify from '@/plugins/vuetify';

import * as ROUTES from '@/constants/ROUTES';
import { FILTROS_ENTREGAS, FILTROS_PESAGENS } from '@/constants/FILTROS';

import {
  layoutRoute, viewRoute, redirectRoute, requireAuthenticated, requireUnauthenticated,
} from '../utils/router';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,

  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    // Hashes usados para abrir telas (#dialog, #selecionar-...) não são
    // elementos da página; o goTo lançaria erro ao não encontrá-los.
    let alvoHash = null;
    try {
      alvoHash = to.hash ? document.querySelector(to.hash) : null;
    } catch (err) {
      alvoHash = null;
    }

    if (alvoHash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    } else if (to.name === from.name) {
      scrollTo = document.documentElement.scrollTop;
    }

    return vuetify.framework.goTo(scrollTo);
  },

  routes: [
    layoutRoute(ROUTES.ROUTE_SIGN_IN.path, 'base', [
      viewRoute({
        name: ROUTES.ROUTE_SIGN_IN.name,
        view: 'sign-in',
      }, requireUnauthenticated),
    ]),

    layoutRoute(ROUTES.ROUTE_HOME.path, 'default', [
      viewRoute({
        name: ROUTES.ROUTE_HOME.name,
        view: 'home',
        appBar: 'AppBar',
      }, requireAuthenticated),
    ]),

    // layoutRoute(ROUTES.ROUTE_VISITANTES.path, 'default', [
    //   viewRoute({
    //     name: ROUTES.ROUTE_VISITANTES.name,
    //     view: 'visitantes',
    //     appBar: 'AppBar',
    //     filters: 'Filters',
    //   }, requireAuthenticated),
    // ]),

    layoutRoute(ROUTES.ROUTE_RECEBIMENTO.path, 'default', [
      viewRoute({
        name: ROUTES.ROUTE_RECEBIMENTO.name,
        view: 'recebimento',
        appBar: 'AppBar',
        ...(FILTROS_ENTREGAS.exibirFiltros && { filters: 'Filters' }),
      }, requireAuthenticated),
    ]),

    layoutRoute(ROUTES.ROUTE_RECEBIMENTO_RESUMO.path, 'default', [
      viewRoute({
        name: ROUTES.ROUTE_RECEBIMENTO_RESUMO.name,
        view: 'recebimento_resumo',
        appBar: 'AppBar',
      }, requireAuthenticated),
    ]),

    layoutRoute(ROUTES.ROUTE_PESAGEM.path, 'default', [
      {
        ...viewRoute({
          name: ROUTES.ROUTE_PESAGEM.name,
          view: 'pesagem',
          appBar: 'AppBar',
          ...(FILTROS_PESAGENS.exibirFiltros && { filters: 'Filters' }),
        }, requireAuthenticated),
        props: true,
      },
    ]),

    layoutRoute(ROUTES.ROUTE_FILA.path, 'default', [
      viewRoute({
        name: ROUTES.ROUTE_FILA.name,
        view: 'fila',
        appBar: 'AppBar',
        filters: 'Filters',
      }, requireAuthenticated),
    ]),

    redirectRoute(ROUTES.ROUTE_HOME),
  ],
});

export default router;
